import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Table, Form, Button } from "react-bootstrap";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";

const getAuthToken = () => localStorage.getItem("authToken");

const MonthlyAttendancePage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const batchIdFromURL = searchParams.get("batch_id");
    const dateFromURL = searchParams.get("date");

    const [selectedBatch, setSelectedBatch] = useState(batchIdFromURL || "");
    const [month, setMonth] = useState(dateFromURL ? dateFromURL.slice(0, 7) : new Date().toISOString().slice(0, 7));
    const [attendanceData, setAttendanceData] = useState([]);
    const [batches, setBatches] = useState([]);

    useEffect(() => {
        fetchBatches();
    }, []);

    useEffect(() => {
        if (selectedBatch) {
            fetchAttendance();
        }
    }, [selectedBatch, month]);

    const fetchBatches = () => {
        const token = getAuthToken();
        if (!token) {
            alert("Unauthorized! Please log in.");
            return;
        }
        axios.get(`${appConstants.API_ROOT_URL}get-batches`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                setBatches(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching batches", error);
            });
    };

    const fetchAttendance = () => {
        const token = getAuthToken();
        if (!token) {
            alert("Unauthorized! Please log in.");
            return;
        }
        axios.post(`${appConstants.API_ROOT_URL}get-monthly-attendance`, 
            { batch_id: selectedBatch, date: month + "-01" },
            { headers: { Authorization: `Bearer ${token}` } }
        )
            .then(response => {
                setAttendanceData(response.data.attendance);
            })
            .catch(error => {
                console.error("Error fetching attendance", error);
            });
    };

    return (
        <Layout>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Attendance</h4>
                
                <button className="btn btn-secondary" onClick={() => navigate(-1)}>Back</button>
            </div>
            <div className="d-flex gap-3 mb-3">
                <Form.Select value={selectedBatch} onChange={e => setSelectedBatch(e.target.value)}>
                    {batches?.length > 0 && (
                        <>
                        {batches.map(batch => (
                        <option key={batch.id} value={batch.id}>{batch.class_name + " " + batch.division}</option>
                    ))}
                        </>
                    )}
                    
                </Form.Select>
                <Form.Control type="month" value={month} onChange={e => setMonth(e.target.value)} />
            </div>

            {attendanceData.length > 0 && (
                <Table striped bordered hover>
                    <thead>
                        <tr>
                        <th style={{ minWidth: '200px' }}>Student</th>

                            {Object.keys(attendanceData[0].attendance).map(date => (
                                <th key={date}>{new Date(date).getDate()}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {attendanceData.map(student => (
                            <tr key={student.student_id}>
                                <td>{student.name}</td>
                                {Object.values(student.attendance).map((status, index) => (
                                    <td key={index} className={status === "P" ? "table-success" : status === "A" ? "table-danger" : ""}>
                                        {status === "P" || status === "A" ? status : ""}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Layout>
    );
};

export default MonthlyAttendancePage;
